import dayjs from "dayjs";
import { FC } from "react";
import { VoteAnswer } from "../../api/events-api";
import { Icon } from "../dss/Icon";

interface Props {
  date: string;
  answer?: VoteAnswer;
  onClick?: () => void;
}

const DateOptionCard: FC<Props> = ({ date, answer = VoteAnswer.NO, onClick }) => {
  const isYes = answer === VoteAnswer.YES;
  const isMaybe = answer === VoteAnswer.MAYBE;
  // Saving a ballot now records an afbud for every date left untouched, so an
  // untouched card has to say so. It says it in a word and a glyph rather than
  // by colouring itself in: arriving at a list of dates none of which you have
  // considered yet, and finding all of them already red, reads as an accusation
  // rather than as the state of the form.
  const status = isYes ? "Kan" : isMaybe ? "Måske" : "Kan ikke";

  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-4 py-3.5 px-4 rounded-lg border text-left ${
        isYes
          ? "bg-vote-yes-soft border-vote-yes text-vote-yes-ink"
          : isMaybe
            ? "bg-vote-maybe-soft border-vote-maybe text-vote-maybe-ink"
            : "bg-card border-line"
      }`}
    >
      <div className="w-10 flex-shrink-0">
        <div className="font-mono text-[9.5px] tracking-wide opacity-70 font-medium uppercase">
          {dayjs(date).format("MMM")}
        </div>
        <div className="font-display font-extrabold text-[30px] leading-[0.92] tracking-tight tabular-nums">
          {dayjs(date).format("DD")}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-[14.5px] font-bold uppercase tracking-tight">
          {dayjs(date).format("D. MMMM YYYY")}
        </div>
        <div className="font-mono text-[10.5px] mt-1 tracking-wide uppercase">
          <span className="opacity-60">{dayjs(date).format("dddd")}</span>
          <span className="opacity-35 mx-1.5">·</span>
          <span className={isYes || isMaybe ? "opacity-80" : "text-clay"}>{status}</span>
        </div>
      </div>
      <div
        className={`w-[30px] h-[30px] rounded flex-shrink-0 flex items-center justify-center ${
          isYes
            ? "bg-vote-yes text-paper"
            : isMaybe
              ? "bg-vote-maybe text-ink"
              : "bg-clay-soft text-clay"
        }`}
      >
        {isYes ? (
          <Icon name="check" size={16} />
        ) : isMaybe ? (
          <Icon name="question" size={16} />
        ) : (
          <Icon name="xmark" size={16} />
        )}
      </div>
    </button>
  );
};

export default DateOptionCard;
